export const ListViewModes = {
    CARD: 0,
    LIST: 1,
};

export const cardInfoList = [
    {
        key: 'DocNumber',
        label: 'Doc Number',
    },
    {
        key: 'Login',
        label: 'Login',
    },
    {
        key: 'Phone',
        label: 'Phone Number',
    },
    {
        key: 'Email',
        label: 'Email Address',
    },
];
